import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { InterceptorService } from './../components/interceptor.service';
import { GenericoEcommerceModule } from '../components/generico-ecommerce.module';
import { MarianoRoutingModule } from './mariano-max-routing.module';
import { AppSharedModule } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { AppComponent } from './app.component';
import { MmaxGeneralComponent } from './mmax-general/mmax-general.component';
import { MarianoMaxtopbarComponent } from './mariano-maxtopbar/mariano-maxtopbar.component';
import { MmaxhomeLandpageComponent } from './mmaxhome-landpage/mmaxhome-landpage.component';
import { FrecuentesMmaxviewComponent } from './frecuentes-mmaxview/frecuentes-mmaxview.component';
import { HelpBarMmaxComponent } from './help-bar-mmax/help-bar-mmax.component';
import { CloudinaryModule } from '@cloudinary/ng';
import { AuthGuard } from './auth.guard';
import { SpinnerComponent } from './spinner/spinner.component';
import { HayCarritoOfflineComponent } from '../components/resumen-comprammax/hay-carrito-offline/hay-carrito-offline.component';

import { CacheInterceptor } from '../components/cache-interceptor.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SocialLoginModule, SocialAuthServiceConfig, SOCIAL_AUTH_CONFIG } from '@abacritt/angularx-social-login';
import { GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { map } from 'rxjs/operators';
import { AppConfigService } from './core/config/app-config.service';

@NgModule({
  declarations: [
    AppComponent,
    MmaxGeneralComponent,
    MarianoMaxtopbarComponent,
    MmaxhomeLandpageComponent,
    FrecuentesMmaxviewComponent,
    HelpBarMmaxComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MarianoRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AppSharedModule,
    GenericoEcommerceModule,
    SocialLoginModule,
    CloudinaryModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    AuthGuard,
    {
      provide: SOCIAL_AUTH_CONFIG,
      useFactory: (appConfigService: AppConfigService) => appConfigService.loadConfig().pipe(
        map(() => ({
          autoLogin: false,
          providers: [
            {
              id: GoogleLoginProvider.PROVIDER_ID,
              provider: new GoogleLoginProvider(appConfigService.getGoogleClientId() || '')
            }
          ],
          onError: (err) => {
            console.error(err);
          }
        } as SocialAuthServiceConfig))
      ).toPromise(),
      deps: [AppConfigService]
    }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
